// NotFoundPage — 404 catch-all. Offers a way back to the marketing page
// or, if the user is signed in, to /app/workout.

import type { ReactElement } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";

export function NotFoundPage(): ReactElement {
  const { t } = useI18n();
  return (
    <main
      data-testid="not-found"
      className="mx-auto flex min-h-screen w-full max-w-[640px] flex-col items-start gap-6 px-6 py-24"
    >
      <p className="font-subhead text-sm uppercase tracking-[0.06em] text-[var(--color-lime)]">
        404
      </p>
      <h1 className="font-display text-5xl uppercase leading-[1.05] tracking-[0.02em] text-[var(--color-ink-hi)]">
        {t("notFound.title")}
      </h1>
      <p
        className="font-sans text-base text-[var(--color-ink-mute)]"
        style={{ lineHeight: 1.5 }}
      >
        {t("notFound.body")}
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <Link
          to="/"
          data-testid="not-found-home"
          className="font-display uppercase tracking-[0.02em] text-[var(--color-void)]"
          style={{
            minHeight: "64px",
            padding: "0 24px",
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "var(--color-lime)",
            borderRadius: "var(--radius-sharp)",
            fontSize: 18,
          }}
        >
          {t("notFound.home")}
        </Link>
        <Link
          to="/app/workout"
          data-testid="not-found-app"
          className="font-sans text-sm text-[var(--color-ink)] underline-offset-2 hover:underline"
        >
          {t("notFound.app")}
        </Link>
      </div>
    </main>
  );
}
